import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { RelaunchComponent } from '../tasks-details-characteristics/relaunch/relaunch.component';
import { BypassComponent } from '../tasks-details-characteristics/bypass/bypass.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-tasks-details-billing',
  templateUrl: './tasks-details-billing.component.html',
  styleUrls: ['./tasks-details-billing.component.css']
})
export class TasksDetailsBillingComponent implements OnInit {
  orderId: string;
  editable: boolean;

  constructor(public dialog: MatDialog) {
  }

  ngOnInit() {
    this.orderId = '';
    this.editable = false;
  }

  ngOnDestroy(): void {
  }

  public relaunch() {
    this.dialog.open(RelaunchComponent, {
      width: '850px'
    });
  }

  public byPass() {
    this.dialog.open(BypassComponent, {
      width: '850px'
    });
  }
}
